import React, { Component } from 'react';
import { history } from "../../../../store";
import IgniteDataTable from '../../../common/datatable';

class PointsTransactionsList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const columns = [
      { prop: 'customer-number', width: '100', title: 'Customer Number', onClick(cell, row) { history.push(`/admin/outlets/${row.attributes['outlet-id']}/view`) } },
      { prop: 'transaction-date', title: 'Transaction Date', width: '150', format(cell, row) { return (<div className="column-white-space">{cell}</div>) } },
      { prop: 'points-pot', title: 'Points Pot', width: '100' },
      { prop: 'value', title: 'Value', width: '100' },
      { prop: 'description', title: 'Description', width: '200', format(cell, row) { return (<div className="column-white-space">{cell}</div>) } },
      { prop: 'user-id', title: 'User id', width: '50' },
      { prop: 'name', title: 'Name', width: '150', format(cell, row) { return (<div className="column-white-space">{cell}</div>) } },
    ];
    return (
      <IgniteDataTable data={this.props.points_transactions}
                       dataSize={this.props.paging.number * this.props.paging.size}
                       columns={columns}
                       pagination={{
                         page:         this.props.currentPage,
                         sizePerPage:  20,
                         onPageChange: this.props.onPageChange,
                       }}
                       remote
                       hideId={false}/>
    )
  }
}

export default PointsTransactionsList;



// WEBPACK FOOTER //
// ./src/components/admin/points/points-transactions/points-transactions-list.jsx